import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import { ASSIGN_ROLE_POLICIES, CREATE_POLICY, DELETE_POLICY, GET_ALL_POLICIES, get_headers, get_project_id, GET_ROLE_POLICIES, REMOVE_ROLE_POLICIES, ROLES_URL } from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import { reactive } from 'vue';

export default {
  name: 'PermissionManagement',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    ProbaWorkflowsSidebar,
    navbar,
    GlobalTable
  },
  data: () => ({
    headers: get_headers(),
    project_id: get_project_id(),
    selected_policy: null,
    selected_role: null,
    roles: [],
    policy_count: 0,
    policy_name: '',
    policy_description: '',
    policies: [],
    policy_headers: [],
    role_policy_assignment: [],
    loading: reactive(new Map()),
  }),
  mounted() {
    this.headers = get_headers();
    this.fetch_roles();
    this.get_policies();
  },
  methods: {
    fetch_roles() {
      axios.get(ROLES_URL, {
        headers: this.headers,
      })
        .then((response) => {
          this.roles = [];
          this.roles = response.data.data.map(role => ({
            id: role.id,
            role: role.role === "Entity" ? "Founder" : role.role,
            description: role.description,
          }));
          this.roles_headers = Object.keys(this.roles[0]);
        })
        .catch((error) => {
          this.show_error('Error fetching roles: ' + error.message);
        });
    },

    select_policy(policy_id){
      this.selected_policy = parseInt(policy_id, 10);
      this.get_role_policies(this.selected_policy);
    },
    policy_management(policy_id) {
      sessionStorage.setItem('policy_id', policy_id);
      this.$router.push('/assigning_permissions');
    },
    assign_role(role_id) {

      const payload = {
        role_id: role_id,
        policy_ids: [this.selected_policy] || null,
      };

      axios.post(ASSIGN_ROLE_POLICIES, payload, {
        headers: this.headers,
      })
        .then(() => {
          this.is_policy_assigned_to_role(this.selected_policy)
          this.show_success('Policy assigned to role successfully');
        })
        .catch((error) => {
          this.show_error('Error assigning policy: ' + error.message);
        });
      },
     delete_policy(policy) {
      this.show_confirm(
        "Delete Policy",
        "Are you sure you want to delete this policy?",
        () => {
          axios.post(`${DELETE_POLICY}`, {
            policy_id: policy.id
          }, {
            headers: this.headers,
          })
          .then((response) => {
            if (response.data.status === "Success") {
              this.show_success(response.data.message);
              this.get_policies();
            } else {
              this.show_error(response.data.message);
            }
          })
          .catch((error) => {
            if (error.response?.data?.message) {
              this.show_error(error.response.data.message);
            } else {
              this.show_error("Error deleting policy");
            }
          });
        }
      );
    },
    submit_policy(){
      if (!validate_non_empty_string(this.policy_name)) {
            this.show_error('Policy name cannot be empty');
            return;
          }

          const payload = {
            name: this.policy_name,
            description: this.policy_description || null,
          };

          const project_id = Number(this.project_id);

          if (Number.isInteger(project_id) && project_id > 0) {
            payload.project_id = project_id;
          }

          axios.post(CREATE_POLICY, payload, {
            headers: this.headers,
          })
            .then(() => {
              this.policies = [];
              this.get_policies()
              this.show_success('Policy created successfully');
              this.close_modal('create_policy')
              location.reload();
            })
            .catch(() => {
              this.show_error('Error creating policy: ' + "Policy with this name already exists");
            });
    },
    get_policies() {
      this.policies = [];
      var query_params = {};

      const project_id = Number(this.project_id);

      if (Number.isInteger(project_id) && project_id > 0) {
        query_params.project_id = project_id;
      }

      axios.get(GET_ALL_POLICIES, {
        headers: this.headers, params: query_params
      })
        .then((response) => {
          this.policy_count = response.data.data.count || 0;
          const data = response.data.data.data;

          if (Array.isArray(data) && data.length > 0) {
            this.policies = data.map(policy => ({
              id: policy.id,
              policy: policy.name,
              description: policy.description,
              'date created': this.format_date(policy.date_created),
            }));
            this.policy_headers = Object.keys(this.policies[0]);
          } else {
            this.policies = [];
            this.policy_headers = ["id", "policy", "description", "date created"];
          }
        })
        .catch((error) => {
          this.show_error("Error fetching policies: " + error.message);
        });
    },

    async get_role_policies(policy_id = null, role_id = null) {
      if (policy_id === null && role_id === null) {
        this.show_error('Please select a policy or role to view permissions.');
        return;
      }
      var payload = {
        policy_id: policy_id,
        role_id: role_id,
      };

      try {
        const response = await axios.post(GET_ROLE_POLICIES, payload, {
          headers: this.headers,
        });
        this.role_policy_assignment = response.data.data
      } catch (error) {
        this.show_error('Error fetching role policies: ' + error.message);
      }
    },

    openViewModal(row) {
      this.selected_policy = row;
    },
    go_back_to_company_management() {
      this.$router.push('/company_management');
    },
    toggle_policy_assignment(role_id) {
      this.loading.set(role_id, true);

      const is_assigned = this.is_policy_assigned_to_role(role_id);
      const payload = {
        role_id: role_id,
        policy_ids: [this.selected_policy]
      };

      const action = is_assigned ? 'unassign' : 'assign';
      const endpoint = is_assigned ? REMOVE_ROLE_POLICIES : ASSIGN_ROLE_POLICIES;

      axios.post(endpoint, payload, {
        headers: this.headers,
      })
      .then((response) => {
        if (response.data.status === "Success") {
          this.show_success(`Policy ${action}ed successfully`);
          this.get_role_policies(this.selected_policy);
        } else {
          this.show_error(response.data.message);
          // Revert the toggle using ref
          const toggle = this.$refs[`policy_toggle${role_id}`];
          if (toggle) {
            toggle.checked = is_assigned;
          }
        }
      })
      .catch((error) => {
        const error_message = error.response?.data?.message || error.message;
        this.show_error(`Error ${action}ing policy: ${error_message}`);
        // Revert the toggle using ref
        const toggle = this.$refs[`policy_toggle${role_id}`];
        if (toggle) {
          toggle.checked = is_assigned;
        }
      })
      .finally(() => {
        this.loading.set(role_id, false);
      });
    },


    // Update is_policy_assigned_to_role to be more robust
    is_policy_assigned_to_role(role_id) {
      return this.role_policy_assignment.some(
        assignment => assignment.role === role_id && assignment.policy === this.selected_policy
      );
    }
  }
};